import React from 'react';

/**
 * Single place for all list filters: status tabs, search, sort — keeps screens simple.
 */
export function FilterSection({ title = 'Filters', hint, children, className = '' }) {
  return (
    <section
      className={[
        'rounded-2xl border border-slate-200/90 bg-slate-50/80 p-4 sm:p-5 space-y-4',
        className,
      ].join(' ')}
      aria-label={title}
    >
      <div>
        <h2 className="text-sm font-bold text-slate-900">{title}</h2>
        {hint ? <p className="mt-0.5 text-xs text-slate-500">{hint}</p> : null}
      </div>
      <div className="space-y-4">{children}</div>
    </section>
  );
}

export default FilterSection;
